import styled from 'styled-components';
import TableChairSvg from '../../assets/amenities/table-chair.svg';

const TableChairIcon = styled(TableChairSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default TableChairIcon;
